import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Subtract20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3 9.25H17V10.75H3V9.25Z'
      fill='currentColor'
    />
  </Svg>
);

Subtract20.displayName = 'Subtract20';
export default Subtract20;
